export interface CustomerStatusConfig {
  icon: string;
  bg: string;
  color: string;
  border: string;
  label: string;
}

export const CUSTOMER_STATUS_CONFIG: Record<
  string,
  CustomerStatusConfig
> = {
  "Proposal Accepted": {
    icon: "fa-solid fa-check-double",
    bg: "rgba(37, 99, 235, 0.10)",
    color: "#2563EB",
    border: "#BFDBFE",
    label: "Proposal Accepted",
  },

  "In Implementation": {
    icon: "fa-solid fa-screwdriver-wrench",
    bg: "rgba(245, 158, 11, 0.10)",
    color: "#D97706",
    border: "#FDE68A",
    label: "In Implementation",
  },

  "Implementation Paid": {
    icon: "fa-solid fa-credit-card",
    bg: "rgba(8, 145, 178, 0.12)",
    color: "#0891B2",
    border: "#A5F3FC",
    label: "Implementation Paid",
  },

  "Go Live": {
    icon: "fa-solid fa-rocket",
    bg: "rgba(22, 163, 74, 0.12)",
    color: "#16A34A",
    border: "#BBF7D0",
    label: "Go Live",
  },
};


export const CUSTOMER_STATUS_BADGE_STYLE = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 10px",
  borderRadius: "999px",
  fontSize: "11px",
  fontWeight: 600,
  letterSpacing: "0.2px",
  transition: "0.2s ease",
};

export const getCustomerStatusConfig = (
  status: string
): CustomerStatusConfig => {
  return (
    CUSTOMER_STATUS_CONFIG[status] ||
    CUSTOMER_STATUS_BADGE_STYLE
  );
};